'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PresenceBadge", {
    enumerable: true,
    get: function() {
        return PresenceBadge;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _usePresenceBadge = require("./usePresenceBadge");
const _usePresenceBadgeStylesstyles = require("./usePresenceBadgeStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _Badge = require("../../Badge");
const PresenceBadge = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _usePresenceBadge.usePresenceBadge_unstable)(props, ref);
    (0, _usePresenceBadgeStylesstyles.usePresenceBadgeStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('usePresenceBadgeStyles_unstable')(state);
    return (0, _Badge.renderBadge_unstable)(state);
});
PresenceBadge.displayName = 'PresenceBadge';
